<template>
  <div>
    <BaseButton primary small @click="addAccount"> Add Client </BaseButton>
  </div>
</template>

<script>
import { contactAccountsClient } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  computed: {
    contact() {
      return this.$store.state.entities.contacts.byId[this.contactId] || null;
    },
  },
  methods: {
    addAccount() {
      this.$modal.show({
        component: () => import('Components/ContactAccounts/AccountAddModal.vue'),
        props: {
          action: this.storeAccount,
          contact: this.contact,
        },
        on: {},
        hideEvent: 'hide',
      });
    },
    async storeAccount(data) {
      try {
        await contactAccountsClient.store(this.contactId, mapKeysToSnakeCase(data));

        this.$emit('account-added');

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
